import { ChangeEvent, Fragment } from 'react';
import { EventOrValueHandler, Field, FormSection } from 'redux-form';

import SelectField, { Option } from 'dashboard/components/FormControls/SelectField';
import { IdCompareOption } from 'dashboard/models/verification-template-version';

export const ID_COMPARE_OPTIONS: Record<IdCompareOption, string> = {
  [IdCompareOption.FirstPassed]: 'Compare to first passed ID verification',
  [IdCompareOption.LastPassed]: 'Compare to last passed ID verification',
  [IdCompareOption.Last]: 'Compare to last passed or failed ID verification',
};

interface SelectSelfieIdCompareOptionProps {
  name: string;
  editable: boolean;
  currentIdCompareOption: IdCompareOption | undefined;
  updateIdCompareOption: (idCompareOption: IdCompareOption) => void;
}

const SelectSelfieIdCompareOption = ({
  name,
  editable,
  currentIdCompareOption,
  updateIdCompareOption,
}: SelectSelfieIdCompareOptionProps) => {
  return (
    <FormSection name={name} component={Fragment}>
      <Field
        id='id-compare-option'
        name='id-compare-option'
        placeholder={currentIdCompareOption && ID_COMPARE_OPTIONS[currentIdCompareOption]}
        component={SelectField}
        disabled={!editable}
        onChange={updateIdCompareOption as EventOrValueHandler<ChangeEvent<IdCompareOption>>}
      >
        {Object.values(IdCompareOption).map((option) => (
          <Option key={option} value={option}>
            {ID_COMPARE_OPTIONS[option]}
          </Option>
        ))}
      </Field>
    </FormSection>
  );
};

export default SelectSelfieIdCompareOption;
